import CloseIcon from '@mui/icons-material/Close';
import { Dialog,DialogContent,DialogTitle,IconButton,Skeleton } from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import AttToken from '../../../helpers/attToken';
import { trackEventMatomo } from '../../../helpers/matomo';
import PlanoDeAcao from '../../../service/PlanoDeAcao';
import { planoDeAcaoType } from '../../../types/plano-de-acao/types';
import AccordionDetailPlan from './DetalhePlano';
import ModalEditPlan from './EditaPlano';

type props = {
  open: boolean,
  handleOpen: Function,
  planIds: string[],
  setPlanIds: Function,
};

const planoService = new PlanoDeAcao();

export default function PlanoPorId({
  planIds,
  setPlanIds,
  open,
  handleOpen,
}: props) {
  const [plano, setPlano] = useState<planoDeAcaoType | null>(null);
  const [openModal, setOpenModal] = useState(false);
  const { t } = useTranslation('translation');

  function handleOpenModal() {
    setOpenModal(!openModal);
  }

  const { data, isLoading, isFetching, isRefetching } = useQuery({
    queryKey: ['GET_PLANO_BY_ID'],
    queryFn: async () => {
      const token = await AttToken();
      if (token) {
        const result = await planoService.getPlansById(token, planIds);
        return result as planoDeAcaoType[];
      }
    },
    retry: 3,
    refetchOnMount: 'always',
    refetchOnWindowFocus: false
  });

  return (
    <>
      {openModal && (
        <ModalEditPlan
          openModal={openModal}
          handleOpen={handleOpenModal}
          plano={plano}
          setPlano={setPlano}
          restarting={false}
        />
      )}
      <Dialog
        fullWidth
        maxWidth='md'
        open={open}
        onClose={() => handleOpen()}
        scroll='paper'
      >
        <DialogTitle>{`${planIds.length} ${t('ActionPlan.Modal.plansOpened')}`}</DialogTitle>
        <IconButton
          aria-label="close"
          onClick={() => {
            handleOpen();
            trackEventMatomo('modal PA por ID', 'click', 'button', 'fecha modal');
            setPlanIds(null);
          }}
          sx={(theme) => ({
            position: 'absolute',
            right: 8,
            top: 8,
            color: theme.palette.grey[500],
          })}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers={true}>
          {isLoading
            || isFetching
            || isRefetching
            ? planIds?.map((_, index) => (
              <Skeleton key={index} variant='rounded' height={100} width={'100%'} />
            ))
            : !data
              || !data.length
              ? <span className='spanInspetor'>{t('ActionPlan.Modal.plansNotFound')}</span>
              : data?.map((plano) => (
                <AccordionDetailPlan key={plano.id} plano={plano} />
              ))}
        </DialogContent>
      </Dialog>
    </>
  );
}
